<template>
  <canvas :id="idChart" />
</template>

<script>
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  props: {
    idChart: String,
    orientation: String,
    values: Array,
    labels: Array,
    thickness: [Number, String],
    colors: Array,
    title: String,
    stacked: Boolean,
    shortLabels: Array,
    displayLegend: {
      type: Boolean,
      required: false,
      default: false,
    },
    maintainAspectRatio: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayValues: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayXaxis: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      datasComplete: this.values,
    };
  },
  mounted() {
    let type;
    let displayValues = this.displayValues;

    this.datasComplete = this.values;
    this.datasComplete.forEach((element) => {
      element.barThickness = this.thickness;
    });

    if (this.orientation == 'vertical') {
      type = 'bar';
    } else if (this.orientation == 'horizontal') {
      type = 'horizontalBar';
    }
    let ctx = document.getElementById(this.idChart);

    let myChart = new Chart(ctx, {
      plugins: [ChartDataLabels],

      type: type,
      major: false,
      data: {
        labels: this.labels,
        datasets: this.values,
      },
      options: {
        plugins: {
          datalabels: {
            color: '#0A0101',
            display: function (context) {
              let index = context.dataIndex;
              let value = context.dataset.data[index];
              return displayValues && value > 0;
            },
            /* align: 'top',
                anchor: 'end', */
          },
        },
        responsive: true,
        maintainAspectRatio: this.maintainAspectRatio,
        scales: {
          xAxes: [
            {
              stacked: this.stacked,
              position: 'bottom',
              gridLines: {
                drawOnChartArea: false,
                drawTicks: false,
              },
              ticks: {
                padding: 10,
                callback: function (value, index, values) {
                  //multiline label to avoid clip it
                  //return value.match(new RegExp('.{1,' + 60 + '}(\\s|$)', 'g'));

                  if (value.length > 30) {
                    return value.substring(0, 30) + '...'; //truncate
                  }

                  return value;
                  //return '';
                },
                display: this.displayXaxis,
              },
            },
          ],
          yAxes: [
            {
              stacked: this.stacked,
              gridLines: {
                drawOnChartArea: false,
                drawTicks: false,
              },
              ticks: {
                padding: 10,
                stepSize: 1,
                min: 0,
              },
            },
          ],
        },
        legend: {
          display: this.displayLegend,
          position: 'bottom',
          align: 'start',
        },
        title: {
          display: true,
          text: this.title.toUpperCase(),
          fontSize: 18,
          fontFamily: 'Montserrat',
          fontColor: '#3A18D1',
          padding: 35,
        },
      },
    });
  },
};
</script>
